import { connect } from "@formily/react";
import { Input } from "@formily/antd-v5";

export const TextArea = connect((props) => {
  const enhancedProps = {
    ...props,
  };

  return <Input.TextArea {...enhancedProps} />;
});
